define('modules/video/player/video_player_model',['backbone'], function(Backbone) {
   'use strict';
    var Model = Backbone.Model.extend({
      defaults: {
        title: 'Default title',
        preview: '',
        poster: '',
        name: '',
        hide_close_button: false
      }
    });

    return Model;
});

